// src/components/remediation/SharedRemediationUI.jsx
import React from "react";
import {
  getTaskStatusLabel,
  getTaskTone,
  getToneColor,
  normalizeText,
} from "../../utils/complianceFormatters";

export function MetricCard({ label, value, footnote, tone = "default" }) {
  const toneStyle =
    tone === "danger"
      ? { color: "var(--danger)" }
      : tone === "warn"
      ? { color: "var(--warn)" }
      : tone === "ok"
      ? { color: "var(--ok)" }
      : tone === "active" || tone === "accent"
      ? { color: getToneColor("active") }
      : {};

  return (
    <div className="hero-kpi">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value small" style={toneStyle}>
        {value}
      </div>
      {footnote ? <div className="hero-kpi-foot">{footnote}</div> : null}
    </div>
  );
}

export function MetaField({ label, value, wrap = false }) {
  return (
    <div className="open-item-pill" style={{ cursor: "default", alignItems: "flex-start" }}>
      <div className="open-item-label">{label}</div>
      <div
        className="open-item-value"
        style={{
          fontSize: 12,
          maxWidth: "100%",
          textAlign: "right",
          whiteSpace: wrap ? "normal" : "nowrap",
          overflow: wrap ? "visible" : "hidden",
          textOverflow: wrap ? "clip" : "ellipsis",
          wordBreak: wrap ? "break-word" : "normal",
          lineHeight: 1.35,
        }}
        title={String(value || "—")}
      >
        {value || "—"}
      </div>
    </div>
  );
}

export function TaskStatusPill({ task }) {
  if (!task) return null;

  const status = normalizeText(task.status);
  const validationStatus = normalizeText(task.validation_status);

  const label =
    validationStatus === "failed"
      ? "Validation Failed"
      : validationStatus === "passed" && status === "validated"
      ? "Validated"
      : getTaskStatusLabel(task.status);

  const tone =
    validationStatus === "failed"
      ? "danger"
      : validationStatus === "passed" && status === "validated"
      ? "ok"
      : getTaskTone(task.status);

  const color = getToneColor(tone);

  return (
    <span
      className="task-severity"
      style={{
        color,
        background: `color-mix(in srgb, ${color}, transparent 90%)`,
        border: `1px solid color-mix(in srgb, ${color}, transparent 70%)`,
        borderRadius: 999,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content",
        minHeight: 0,
        padding: "3px 8px",
        fontSize: 11,
        lineHeight: 1.1,
        fontWeight: 800,
        whiteSpace: "nowrap",
        letterSpacing: 0,
      }}
      title={task.owner_name ? `Owner: ${task.owner_name}` : "Remediation task exists"}
    >
      Task: {label}
    </span>
  );
}

export function getSelectableCardStyle(isSelected = false) {
  return {
    borderLeft: isSelected ? "3px solid var(--accent)" : "3px solid transparent",
    boxShadow: isSelected
      ? "inset 0 0 0 1px color-mix(in srgb, var(--accent), transparent 55%)"
      : undefined,
    background: isSelected
      ? "color-mix(in srgb, var(--accent), transparent 94%)"
      : undefined,
    transition: "border-color 160ms ease, background 160ms ease, transform 160ms ease, box-shadow 160ms ease",
    cursor: "pointer",
  };
}

export function getSelectableTableRowStyle(isSelected = false) {
  return {
    background: isSelected
      ? "color-mix(in srgb, var(--accent), transparent 92%)"
      : undefined,
    boxShadow: isSelected
      ? "inset 3px 0 0 color-mix(in srgb, var(--accent), transparent 15%)"
      : undefined,
    transition: "background 160ms ease, box-shadow 160ms ease",
    cursor: "pointer",
  };
}
